// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
// import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
// import ZenClusterColumnVer from "./Common/Graph/ZenClusterColumnVer";
import ZenDonut from "./Common/Graph/ZenDonut";

import ZenGauge from "./Common/Graph/ZenGauge";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ApqoDashboard extends React.Component {
  state = {
    mainData: null,
    ZenVerBarChart: null,
    ZenGaugeCurrentMonthStatus: null,
    ZenHorBarChartDIAA: null,
    ZenVerBarChartPlantWIseCost: null,
    ZenDonutDIAA: null,
    ZenVerBarChartCustomerWiseCost: null,
    ZenVerBarChartEfficiency: null,
    ZenVerBarChartInputManHr: null,
    ZenVerBarChartInputManHrCost: null,
    ZenVerBarChartOutputManHr: null,
    ZenVerBarChartOutputManHrCost: null,
    ZenVerBarChartCarlineCost: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/zen/dashboard/apqo", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
       
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};

        respData["ZenVerBarChartMonthWiseAV"] =
          resp["data"]["ZenVerBarChartMonthWiseAV"];
        respData["AngelaAV"] = resp["data"]["AngelaAV"];

        respData["ZenVerBarChartMonthWisePE"] =
          resp["data"]["ZenVerBarChartMonthWisePE"];
        respData["AngelaPE"] = resp["data"]["AngelaPE"];

        respData["ZenVerBarChartMonthWiseQA"] =
          resp["data"]["ZenVerBarChartMonthWiseQA"];
        respData["AngelaQA"] = resp["data"]["AngelaQA"];

        respData["ZenVerBarChartMonthWiseOEE"] =
          resp["data"]["ZenVerBarChartMonthWiseOEE"];
        respData["AngelaOEE"] = resp["data"]["AngelaOEE"];

        respData["mainData"] = { ...resp };

        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
        ? "all"
        : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to="/dashboard">
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>
                <Row>
                  <Col span={24}>
                    {this.state.mainData ? (
                      <div
                        style={{
                          margin: "10px",
                          padding: "10px",
                        }}
                      >
                        <div
                          style={{
                            color: "#bdc3c7",
                            fontSize: 36,
                            fontWeight: 800,
                            textAlign: "center",
                            margin: "0px 0px 0px 0px",
                          }}
                        >
                          PERFORMANCE DASHBOARD
                        </div>
                      </div>
                    ) : null}
                  </Col>
                  <Col span={8} style={{}}></Col>

                  <Col span={12}></Col>
                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>



















          <Row>
            {/* _______________________-AV */}
            <Col span={12}>
              <Row
                style={{
                  background: "#000000",
                }}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 20px 20px 20px",
                    width: "96%",
                  }}
                >
                  <Row>
                    <Col span={8}>
                      <img
                        className="spin"
                        src={this.state.AngelaAV.data.img.src}
                        alt={this.state.AngelaAV.data.img.alt}
                        style={this.state.AngelaAV.config.img}
                      ></img>
                    </Col>

                    <Col span={16}>
                      <div style={this.state.AngelaAV.config.txt0}>
                        {this.state.AngelaAV.data.txt0.txt}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={8}>
                      <span style={this.state.AngelaAV.config.txt1A}>
                        {this.state.AngelaAV.data.txt1A.txt}
                      </span>

                      <span style={this.state.AngelaAV.config.txt1B}>
                        {this.state.AngelaAV.data.txt1B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaAV.config.txt2A}>
                        {this.state.AngelaAV.data.txt2A.txt}
                      </span>

                      <span style={this.state.AngelaAV.config.txt2B}>
                        {this.state.AngelaAV.data.txt2B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaAV.config.txt3A}>
                        {this.state.AngelaAV.data.txt3A.txt}
                      </span>

                      <span style={this.state.AngelaAV.config.txt3B}>
                        {this.state.AngelaAV.data.txt3B.txt}
                      </span>
                    </Col>
                  </Row>
                  <br></br>

                  <Row>
                    
                      <div
                        style={{
                          borderRadius: "10px",
                          background: "#30333a",
                          border: "1px solid #3c3e4f",
                          margin: "10px 10px 10px 10px",

                          width: "96%",
                        }}>
                        <ZenVerBarChart
                          divId={"ZenVerBarChartMonthWiseAV"}
                          data={this.state.ZenVerBarChartMonthWiseAV.data}
                          config={this.state.ZenVerBarChartMonthWiseAV.config}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      </div>
                   
                  </Row>
                </div>
              </Row>
            </Col>

            {/* _______________________-PE */}

            <Col span={12}>
              <Row
                style={{
                  background: "#000000",
                }}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 20px 20px 20px",
                    width: "96%",
                  }}
                >
                  <Row>
                    <Col span={8}>
                      <img
                        className="spin"
                        src={this.state.AngelaPE.data.img.src}
                        alt={this.state.AngelaPE.data.img.alt}
                        style={this.state.AngelaPE.config.img}
                      ></img>
                    </Col>

                    <Col span={16}>
                      <div style={this.state.AngelaPE.config.txt0}>
                        {this.state.AngelaPE.data.txt0.txt}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={8}>
                      <span style={this.state.AngelaPE.config.txt1A}>
                        {this.state.AngelaPE.data.txt1A.txt}
                      </span>

                      <span style={this.state.AngelaPE.config.txt1B}>
                        {this.state.AngelaPE.data.txt1B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaPE.config.txt2A}>
                        {this.state.AngelaPE.data.txt2A.txt}
                      </span>

                      <span style={this.state.AngelaPE.config.txt2B}>
                        {this.state.AngelaPE.data.txt2B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaPE.config.txt3A}>
                        {this.state.AngelaPE.data.txt3A.txt}
                      </span>

                      <span style={this.state.AngelaPE.config.txt3B}>
                        {this.state.AngelaPE.data.txt3B.txt}
                      </span>
                    </Col>
                  </Row>
                  <br></br>

                  <Row>
                 
                    <div
                        style={{
                          borderRadius: "10px",
                          background: "#30333a",
                          border: "1px solid #3c3e4f",
                          margin: "10px 10px 10px 10px",

                          width: "96%",
                        }}>
                        <ZenVerBarChart
                          divId={"ZenVerBarChartMonthWisePE"}
                          data={this.state.ZenVerBarChartMonthWisePE.data}
                          config={this.state.ZenVerBarChartMonthWisePE.config}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      </div>
                   
                  </Row>
                </div>
              </Row>
            </Col>
          </Row>

          <Row>
            {/* _______________________-QA */}
            <Col span={12}>
              <Row
                style={{
                  background: "#000000",
                }}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 20px 20px 20px",
                    width: "96%",
                  }}
                >
                  <Row>
                    <Col span={8}>
                      <img
                        className="spin"
                        src={this.state.AngelaQA.data.img.src}
                        alt={this.state.AngelaQA.data.img.alt}
                        style={this.state.AngelaQA.config.img}
                      ></img>
                    </Col>

                    <Col span={16}>
                      <div style={this.state.AngelaQA.config.txt0}>
                        {this.state.AngelaQA.data.txt0.txt}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={8}>
                      <span style={this.state.AngelaQA.config.txt1A}>
                        {this.state.AngelaQA.data.txt1A.txt}
                      </span>

                      <span style={this.state.AngelaQA.config.txt1B}>
                        {this.state.AngelaQA.data.txt1B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaQA.config.txt2A}>
                        {this.state.AngelaQA.data.txt2A.txt}
                      </span>

                      <span style={this.state.AngelaQA.config.txt2B}>
                        {this.state.AngelaQA.data.txt2B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaQA.config.txt3A}>
                        {this.state.AngelaQA.data.txt3A.txt}
                      </span>

                      <span style={this.state.AngelaQA.config.txt3B}>
                        {this.state.AngelaQA.data.txt3B.txt}
                      </span>
                    </Col>
                  </Row>
                  <br></br>

                  <Row>
                 
                    <div
                        style={{
                          borderRadius: "10px",
                          background: "#30333a",
                          border: "1px solid #3c3e4f",
                          margin: "10px 10px 10px 10px",

                          width: "96%",
                        }}>
                        <ZenVerBarChart
                          divId={"ZenVerBarChartMonthWiseQA"}
                          data={this.state.ZenVerBarChartMonthWiseQA.data}
                          config={this.state.ZenVerBarChartMonthWiseQA.config}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      </div>
                  
                  </Row>
                </div>
              </Row>
            </Col>

            {/* _______________________- */}
            <Col span={12}>
              <Row
                style={{
                  background: "#000000",
                }}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 20px 20px 20px",
                    width: "96%",
                  }}
                >
                  <Row>
                    <Col span={8}>
                      <img
                        className="spin"
                        src={this.state.AngelaOEE.data.img.src}
                        alt={this.state.AngelaOEE.data.img.alt}
                        style={this.state.AngelaOEE.config.img}
                      ></img>
                    </Col>

                    <Col span={16}>
                      <div style={this.state.AngelaOEE.config.txt0}>
                        {this.state.AngelaOEE.data.txt0.txt}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={8}>
                      <span style={this.state.AngelaOEE.config.txt1A}>
                        {this.state.AngelaOEE.data.txt1A.txt}
                      </span>

                      <span style={this.state.AngelaOEE.config.txt1B}>
                        {this.state.AngelaOEE.data.txt1B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaOEE.config.txt2A}>
                        {this.state.AngelaOEE.data.txt2A.txt}
                      </span>

                      <span style={this.state.AngelaOEE.config.txt2B}>
                        {this.state.AngelaOEE.data.txt2B.txt}
                      </span>
                    </Col>

                    <Col span={8}>
                      <span style={this.state.AngelaOEE.config.txt3A}>
                        {this.state.AngelaOEE.data.txt3A.txt}
                      </span>

                      <span style={this.state.AngelaOEE.config.txt3B}>
                        {this.state.AngelaOEE.data.txt3B.txt}
                      </span>
                    </Col>
                  </Row>
                  <br></br>

                  <Row>
                  
                    <div
                        style={{
                          borderRadius: "10px",
                          background: "#30333a",
                          border: "1px solid #3c3e4f",
                          margin: "10px 10px 10px 10px",

                          width: "96%",
                        }}>
                        <ZenVerBarChart
                          divId={"ZenVerBarChartMonthWiseOEE"}
                          data={this.state.ZenVerBarChartMonthWiseOEE.data}
                          config={this.state.ZenVerBarChartMonthWiseOEE.config}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      </div>
                  
                  </Row>
                </div>
              </Row>
            </Col>
          </Row>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default ApqoDashboard;
